import { render, staticRenderFns } from "./radioItem.vue?vue&type=template&id=3630d208&scoped=true"
import script from "./radioItem.vue?vue&type=script&lang=js"
export * from "./radioItem.vue?vue&type=script&lang=js"
import style1 from "./radioItem.vue?vue&type=style&index=1&id=3630d208&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3630d208",
  null
  
)

export default component.exports